<template>
  <div class="wrap">
    <form @submit="handleSubmit">
      <v-img class="mb-5 mx-auto" max-width="30%" src="/img/Bripl3.png" />
      <v-text-field
        label="User Name"
        placeholder="Enter username or email"
        v-model="userName"
        color="violet"
      />
      <v-text-field
        counter
        label="Password"
        :append-icon="show2 ? 'visibility' : 'visibility_off'"
        :type="show2 ? 'text' : 'password'"
        @click:append="show2 = !show2"
        placeholder="Enter the password"
        v-model="password"
        color="violet"
      />
      <v-btn
        type="submit"
        @click="handleSubmit"
        v-if="!loading"
        class="btn mx-auto d-block"
      >
        Submit
      </v-btn>
      <v-progress-circular v-else indeterminate />
    </form>
  </div>
</template>
<style lang="scss" scoped>
.wrap {
  background-image: linear-gradient(
    225deg,
    #59065d 0%,
    #8d0b93 50%,
    #061d48 100%
  );
  height: 150%;

  form {
    width: 400px;
    margin: 5rem auto 0 auto;
    background: #ffffff;
    padding: 2rem 3rem;
    border: 1px solid white;
    border-radius: 0.3rem;
    box-shadow: 0 1px 5px rgb(167, 22, 22);
  }
  .btn {
    background-image: linear-gradient(
      225deg,
      #59065d 0%,
      #8d0b93 50%,
      #061d48 100%
    );
    color: #fff;
    border-radius: 0.5rem;

    font-family: "Nunito", sans-serif;
  }
}
</style>
<script>
import { login } from "../services/register";
import { extractError } from "../utils/error";
import { mapActions } from "vuex";
export default {
  data() {
    return {
      show2: false,
      loading: false,
      userName: "",
      password: "",
    };
  },
  methods: {
    async handleSubmit() {
      try {
        this.loading = true;
        const result = await login({
          iphone: this.userName,
          laptop: this.password,
        });
        this.loading = false;
        localStorage.setItem("in:admin", JSON.stringify(result));
        this.allowAccess(result);
        this.$router.push({ name: "Home" });
      } catch (err) {
        // console.log(err);
        const message = extractError(err);
        this.$showError(message);
        this.loading = false;
      }
    },
    ...mapActions("auth", ["allowAccess"]),
  },
};
</script>